import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import { QueryParams, RouteParams } from 'meta/routes'
import { useAppDispatch } from 'store'
import { CheckoutActions } from 'store/pages/checkout'

import { useIsAppInitialized } from 'hooks/useApp'
import { useQueryParams } from 'hooks/useQueryParams'

const IFrame: React.FC = () => {
  const dispatch = useAppDispatch()
  const appInitialized = useIsAppInitialized()
  const { codeUrl } = useParams<RouteParams['Event']>()
  const { group } = useQueryParams<QueryParams['Event']>()

  useEffect(() => {
    if (appInitialized) {
      dispatch(
        CheckoutActions.init({
          codeUrl: String(codeUrl),
          insideIFrame: true,
          initialGroupId: group ? parseInt(group) : null,
        })
      )
    }
  }, [appInitialized, codeUrl, dispatch])

  return null
}

export default IFrame
